import { ShopifyProductFieldType } from "@redotech/redo-prisma-client/enums";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum CatalogListingType {
  Shopify = "shopify",
  Amazon = "amazon",
}
export const CatalogListingTypeSchema = createEnum(CatalogListingType);

export const ShopifyListingOptimizableFields = [
  ShopifyProductFieldType.title,
  ShopifyProductFieldType.description,
  ShopifyProductFieldType.handle,
  ShopifyProductFieldType.seo_title,
  ShopifyProductFieldType.seo_description,
  ShopifyProductFieldType.product_type,
];
export const ShopifyListingOptimizableFieldSchema = createEnum(
  ShopifyListingOptimizableFields,
);
export type ShopifyListingOptimizableFieldType = z.infer<
  typeof ShopifyListingOptimizableFieldSchema
>;

// ALEX TODO: Make these actually accurate when we get Amazon listings working
export const AmazonListingOptimizableFieldSchema = createEnum(["title"]);
export type AmazonListingOptimizableFieldType = z.infer<
  typeof AmazonListingOptimizableFieldSchema
>;

export const CatalogListingOptimizableFieldSchema = {
  [CatalogListingType.Shopify]: ShopifyListingOptimizableFieldSchema,
  [CatalogListingType.Amazon]: AmazonListingOptimizableFieldSchema,
};

export type CatalogListingOptimizableFieldType = {
  [key in CatalogListingType]: (typeof CatalogListingOptimizableFieldSchema)[key] extends z.ZodType<
    infer T
  >
    ? T
    : never;
};

export function filterOptimizableFields<T extends CatalogListingType>(
  listingType: T,
  fields: string[],
): CatalogListingOptimizableFieldType[T][] {
  return fields.filter(
    (field): field is CatalogListingOptimizableFieldType[T] =>
      CatalogListingOptimizableFieldSchema[listingType].safeParse(field)
        .success,
  );
}
